import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { VoiceBroadcastDetailsSchema } from "../../Schemas/Broadcast";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";

interface BroadcastingDetailsUrlParams {
  broadcastingNumber: string;
}

export interface BroadcastingDetailsResponseBody extends IResponseBody {
  data: {
    voice_broadcast: VoiceBroadcastDetailsSchema;
  };
}
export interface VoiceBroadCastReportSchema {
  total: number;
  call_input: null | string;
  status: string;
}

export interface BroadcastingReportResponseBody extends IResponseBody {
  data: {
    number_reports: VoiceBroadCastReportSchema[];
  };
}

export interface BroadcastingExportResponseBody extends IResponseBody {
  data: {
    url: string;
  };
}

export interface BroadcastingNumberResponseBody extends IResponseBody {
  data: {
    total: number;
    voice_broadcast_numbers: {
      id: number;
      voice_broadcast_id: number;
      pbx_channel_reference_code: null;
      number: string;
      extension: null | string;
      call_input: null | string;
      total_waiting_time: null | string;
      total_talk_time: null | string;
      total_cast: null | string;
      tries: number;
      status: string;
      created_at: null | string;
      updated_at: null | string;
    }[];
  };
}

interface BroadcastingReportListQueryString extends IListQueryStringSchema {
  filters?: FilterReport[];
  sorts?: SortReport[];
}
export interface BroadcastingExportResponseBody extends IResponseBody {
  data: {
    url: string;
  };
}

interface BroadCastExportListQueryString extends IListQueryStringSchema {
  filters?: FilterExport[];
}

export enum BroadcastExportListFilters {
  NUMBER = "number",
  TRIES = "tries",
  CALL_INPUT = "call_input",
  TOTAL_WAITING_TIME = "total_waiting_time",
  TOTAL_TALK_TIME = "total_talk_time",
  TOTAL_CAST = "total_cast",
  STATUS = "status",
}
interface FilterExport extends IFilterSchema {
  column: BroadcastExportListFilters;
}

export enum BroadcastingReportListColumnFilterable {
  NUMBER = "number",
  EXTENSION = "extension",
  CALL_INPUT = "call_input",
  TOTAL_WAITING_TIME = "total_waiting_time",
  TOTAL_TALK_TIME = "total_talk_time",
  TOTAL_CAST = "total_cast",
  TRIES = "tries",
  ESTIMATED_COST = "estimated_cost",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}

interface FilterReport extends IFilterSchema {
  column: BroadcastingReportListColumnFilterable;
}

interface SortReport extends ISortSchema {
  column: BroadcastingReportListColumnFilterable;
}
export class BroadcastingDetailsRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(ticketDetailsUrlParams: BroadcastingDetailsUrlParams) {
    return `/admin/voice-broadcasts/${ticketDetailsUrlParams.broadcastingNumber}`;
  }

  async send(
    ticketDetailsUrlParams: BroadcastingDetailsUrlParams
  ): Promise<BroadcastingDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(ticketDetailsUrlParams) + "/details"
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async report(
    ticketDetailsUrlParams: BroadcastingDetailsUrlParams,
    queryStrings?: BroadcastingReportListQueryString
  ): Promise<BroadcastingReportResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(ticketDetailsUrlParams) + "/report",
        {
          params: queryStrings,
        }
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async cancel(
    ticketDetailsUrlParams: BroadcastingDetailsUrlParams
  ): Promise<BroadcastingDetailsResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(ticketDetailsUrlParams) + "/cancel"
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async numberList(): Promise<BroadcastingNumberResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        "/admin/voice-broadcast-numbers"
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
  async export(
    id: number,
    queryStrings?: BroadCastExportListQueryString
  ): Promise<BroadcastingExportResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        `/admin/voice-broadcasts/${id}/make-export`,
        { params: queryStrings }
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
